import { graphql, useStaticQuery } from "gatsby";

export const GetOppturtunities = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpOppturtunity {
        nodes {
          jobTitle
          jobLocation
          jobDescription
        }
      }
    }
  `);
  return data.allWpOppturtunity.nodes;
};
